import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import queryString from 'query-string';
import {initNavbarState} from 'actions/navbar.js';
import {fetchMyProfile} from 'actions/user.js';
import {fetchPlugins} from 'actions/plugins.js';
import {getPlugins} from 'reducers/plugins.js';
import ChallengeService from 'services/ChallengeService.js';
import PluginService from 'services/PluginService.js';
import UserService from 'services/UserService.js';
import Keys from 'keys/keys.js';
import _ from 'underscore';

import Plugins from './Plugins.js';


export const handleAuthenticationQueryString = (location, history, promise, pluginData) => {
    if(promise===null || promise===undefined) {
        promise = Promise.resolve();
    }
    var search = queryString.parse(location.search);
    console.log('Plugins.loadData - search: ', JSON.stringify(search));
    if(search.auth == "google") {
        var id = sessionStorage.pluginId;
        delete sessionStorage.pluginId;
        console.log('Plugins.loadData - auth==google, id=: ' + id);
        console.log("Plugins.loadData - sessionStorage: ", sessionStorage);
        var code = search.code;
        promise = promise.then(function(){
            return UserService.addUserPlugin(id, {code:code,redirect_uri:Keys.GOOGLE_REDIRECT_URI, ...pluginData});
        }).catch(function() {
            return Promise.resolve();
        });
        
    }
    //Removes querystring from URL
    history.replace(location.pathname);
    return promise;
}


class PluginsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {loadingData:false, deadLinks:[]};
        this.connect = this.connect.bind(this)
        this.pluginFilter = this.pluginFilter.bind(this)
        this.disconnect = this.disconnect.bind(this)
        this.imageLoadError= this.imageLoadError.bind(this)
        this.isDeadLink= this.isDeadLink.bind(this)
    }

    componentWillMount() {
        if(!this.props.noNav) {
            this.props.dispatch(initNavbarState({enable:true, mode:'main', title:this.props.t('Connect Devices'), menuEnable:true, backButtonEnable:false, rewardsEnable:true}));
        }
        this.loadData();
    }


    loadData() {

        this.setState({loadingData:true});
      
 
        var promise = Promise.resolve();

        handleAuthenticationQueryString(this.props.location, this.props.history, promise);



        promise.then(()=>(this.props.loadData()))
               .catch((error)=> {
                   console.error('ERROR:');
                   console.error(error);
                })
                .then(()=>{
                    this.setState({loadingData:false});
                });
    }

    pluginFilter(plugin) {
        return plugin.forWeb==true && (!this.props.typeTag || plugin.pluginType.tag===this.props.typeTag);
    }

    isPluginConnected(pluginId) {
        return (this.props.userPlugins.indexed[pluginId]!=null);
    }

    connect(plugin) {
        sessionStorage.oauth2callbackRedirect = this.props.oauth2callbackRedirect || this.props.location.pathname;
        if(this.props.onConnect) {
            this.props.onConnect(plugin);
        }
        this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:true});
        PluginService.connect(plugin)
            .catch((error)=>{
                console.error('Plugins.connect - error ', error);
                //Only hide loading overlay on error, otherwise we will be redirected away
                this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:false});
            });
    }

    disconnect(plugin) {
        this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:true});
        PluginService.disconnect(plugin)
            .then(()=>(this.props.loadData()))
            .catch((error)=>{
                console.error('Plugins.disconnect - error ', error);
            })
            .then(()=>{
                this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:false});
            });
    }

    listPlugins() {
        return this.props.plugins.map((plugin)=>({...plugin, connected:this.isPluginConnected(plugin.id)})).filter(this.pluginFilter)
    }

    imageLoadError(event) {
        var src = event.target.src;
        this.setState(state=>({deadLinks:state.deadLinks.concat(src)}));
    }

    isDeadLink(url) {
        return this.state.deadLinks.indexOf(url)>=0;
    }

    render() {
        var plugins = this.listPlugins();
        var [connectedPlugins, disconnectedPlugins] = _.partition(plugins, p=>p.connected);
        return <Plugins connectedPlugins={connectedPlugins}
                        disconnectedPlugins={disconnectedPlugins}
                        loadingData={this.state.loadingData}
                        connect={this.connect} 
                        disconnect={this.disconnect}
                        imageLoadError={this.imageLoadError}
                        isDeadLink={this.isDeadLink}
                        style={this.props.style}   
                        bodyStyle={this.props.bodyStyle}>   
                    {this.props.children}
                </Plugins>;
    }

}


const mapStateToProps = (state, ownProps) => {
    return {plugins:getPlugins(state.plugins), userPlugins:state.userPlugins};
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadData: () => dispatch(fetchPlugins({sync:true}, true))
                            .then(()=>(dispatch(fetchMyProfile({plugins:true})))),
        dispatch: dispatch
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(translate('plugins')(PluginsContainer)));



// WEBPACK FOOTER //
// ./src/modules/plugins/PluginsContainer.js